export default {
    TWITTER_LINK: "",
    TELEGRAM_LINK: "",
    LINKEDIN_LINK: ""
}